import { IconPropTypes } from './types';

const CircleIcon = ({ width, height, color }: IconPropTypes) => (
  <svg width={width} height={height} viewBox="0 0 17 17" fill="none">
    <circle cx="8.5" cy="8.5" r="7.5" stroke="white" strokeWidth="2" />
  </svg>
);

export default CircleIcon;
